<div class="wrapper">
    <app-advanced-gridview
        [dataSource]="dataSource"
        [size]="size"
        [model]="filteredTableModel"
        [sortEnabled]="false"
        [menuItems]="menuItems"
        [contextualMenu]="true"
        (menuClicked)="onAction($event)"
        (rowClicked)="onSelection($event)"
        class="gridview"></app-advanced-gridview>
</div>
